// eslint-disable-next-line import/prefer-default-export
export const MOBILE_CONTROLS_HEIGHT = 55;
